export default "https://storage.googleapis.com/prepweb-prod/dist/e328db94da3e0b22c12d25700a89969c.svg";